import axiosInstance from "../../../interceptors/token";
import { API_BASE_URL } from "../../../constants";
import translateText from "../../../util";

export const fetchProjects = async (selectedDate, language, setPreviousWorkDayFault, setProjects, setProjectsLoading, setTimingData, setTranslatedDescriptions) => {
    setProjectsLoading(true);

    try {
        const response = await axiosInstance.get(`${API_BASE_URL}projects/?date=${selectedDate}`);
        const projects = response.data;
        setPreviousWorkDayFault(false);

        // Fetch timing data for each project
        const timingPromises = projects.map((project) =>
            axiosInstance
                .get(`${API_BASE_URL}projects/${project.project_id}/werk/timing/`, { params: { date: selectedDate } })
                .then((res) => ({ [project.project_id]: res.data }))
                .catch(() => ({ [project.project_id]: null }))
        );

        const timingData = Object.assign({}, ...(await Promise.all(timingPromises)));
        setTimingData(timingData);
        
        setProjects(projects);
        setProjectsLoading(false);

        // Fetch translations for descriptions
        const translations = await Promise.all(
            projects.map(async (project) => ({
                projectId: project.project_id,
                description: await translateText(project.description, language),
            }))
        );

        const translationsMap = translations.reduce((acc, curr) => {
            acc[curr.projectId] = curr.description;
            return acc;
        }, {});

        setTranslatedDescriptions(translationsMap);
    } catch (error) {
        if (error.response?.status === 403) {
            setPreviousWorkDayFault(error.response?.data['work_day']);
        } else {
            console.error("Error fetching projects or timings:", error);
        }
        setProjects([]);
        setProjectsLoading(false);
    }
};
